export const defaultColors = {
  primary: '#0C1FAA',
  secondary: '#1D1D1D',
  white: '#FFFF',
  other: '#23155B',
};

export const defaultBorder = {
  primary: '#23155B',
  secondary: '#e5e7eb',
  third: '#000000',
  hover: '#0e1a73'
};

export const defaultButton = {
  primary: '#0E1A73',
  secondary: '#0C1FAA',
  third: '#0E1A73'
};

export const defaultBackground = {
  primary: '#1E40AF',
  secondary: '#E2E5FA',
  third: '#F8F8F8',
  hover: '#0e1a73'
};

export const defaultStyleGuide = {
  colors: defaultColors,
  border: defaultBorder,
  button: defaultButton,
  background: defaultBackground
};

export const defaultLogo = '/img/new-logo.png';
